module.exports = __webpack_public_path__ + "img/telemedicine.5cdeebe9.svg";